/* eslint-disable jsx-a11y/media-has-caption */
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';

import styles from '../../styles/partials/video.module.css';

interface VideoProps {
    url?: string | null;
    medias?: {
        url?: string | null;
        mime?: string | null;
    }[];
    thumbnail?: string | null;
    autoPlay?: boolean;
    isPoster?: boolean;
    // animated?: boolean;
    className?: string | null;
}

const Video = ({
    url = null,
    medias = null,
    thumbnail = null,
    autoPlay = true,
    isPoster = false,
    // animated = false,
    className = null,
}: VideoProps) => {
    const videoRef = useRef<HTMLVideoElement>(null);

    // const [hovering, setHovering] = useState(false);
    // useEffect(() => {
    //     const videoElement = videoRef.current || null;
    //     if (animated && videoElement !== null) {
    //         const handleMouseEnter = () => {
    //             setHovering(true);
    //         };
    //         const handleMouseLeave = () => {
    //             setHovering(false);
    //         };
    //         videoElement.addEventListener('mouseenter', handleMouseEnter);
    //         videoElement.addEventListener('mouseleave', handleMouseLeave);
    //         return () => {
    //             videoElement.removeEventListener('mouseenter', handleMouseEnter);
    //             videoElement.removeEventListener('mouseleave', handleMouseLeave);
    //         };
    //     }
    //     return undefined;
    // }, [videoRef, animated, setHovering]);

    // useEffect(() => {
    //     const videoElement = videoRef.current || null;
    //     if (animated && videoElement !== null) {
    //         if (hovering === true) {
    //             videoElement.play().catch(() => {
    //                 // do nothing
    //             });
    //         } else {
    //             videoElement.pause();
    //         }
    //     }
    // }, [videoRef, animated, hovering]);

    return url !== null || thumbnail !== null || (medias !== null && medias.length > 0) ? (
        <video
            className={classNames([
                styles.container,
                styles.video,
                { [className]: className !== null },
            ])}
            ref={videoRef}
            src={!isPoster && url !== null ? `${url}#t=0.01` : null}
            poster={thumbnail}
            autoPlay={autoPlay && !isPoster}
            loop
            muted
            playsInline
            preload="auto"
        >
            {(medias || []).map((media, index) =>
                media.url !== null && media.mime !== null ? (
                    <source key={index} src={media.url} type={media.mime} />
                ) : null,
            )}
        </video>
    ) : null;
};

export default Video;
